<script>
    import { calculateEecImage } from "../utils/eecUtil";
    import { getContext, tick } from "svelte";
    import { key as svgImageUrlPrefixCtxKey } from "../context/svgImageUrlPrefix";
    import { key as cinemaTileDimensionCtxKey } from "../context/cinemaTileDimension.js";
    import { generateRandomId } from "../utils/IdentifierGenerator.js";

    /**
 *
 *
 *
 *
 */
    /**
 *
 */

    let { energyEfficiencyClasses, isBrand, useNewEECLabel = false } = $props();
    let randomSheetId = generateRandomId();

    const svgImageUrlPrefix = getContext(svgImageUrlPrefixCtxKey);

    let isOnlyDevice = Array.isArray(energyEfficiencyClasses) && energyEfficiencyClasses.length === 1;

    const isPopupAvailable = (energyEfficiencyClass) =>
        energyEfficiencyClass.images[0].uriTemplate && (isOnlyDevice || energyEfficiencyClass.component);

    const calculateClasses = (energyEfficiencyClass) => {
        const popupClasses = isPopupAvailable(energyEfficiencyClass)
            ? "reco_cinema__article-eek-label-img js_openInPaliLayer clickable"
            : "";
        return `${popupClasses}`;
    };

    const getComponentLabel = (component) => {
        if (component) {
            return `<h2 class="reco_cinema__article-eek-layer-title reco_cinema__article-eek-layer-label">${component}</h2>`;
        }
        return "";
    };

    const getDataSheetLabel = (dataSheetHref) => {
        if (dataSheetHref) {
            return `<a class="pl_link100--primary reco_cinema__article-eek-layer-datasheet reco_cinema__article-eek-layer-label"
                        href="${dataSheetHref}" target="_blank" rel="noopener noreferrer" data-target="_blank"><span>Produktdatenblatt (PDF)</span></a>`;
        }
        return "";
    };

    const maxWidthStyle = () => {
        const { width: widthAmount } = getContext(cinemaTileDimensionCtxKey);
        const calculatedMaxWidth = `${widthAmount - 51}px`;
        return isBrand ? `max-width: ${calculatedMaxWidth}` : "";
    };

    const getLabelHtmlSnippet = (energyEfficiencyClass) => {
        if (!energyEfficiencyClass.images[0].uriTemplate) {
            return '<div class="reco_cinema__article-eek-layer-container"><p class="p_copy100">Aktuell stehen leider keine weiteren Informationen zur Energieeffizienzklasse dieses Artikels zur Verfügung.</p></div>';
        }

        let eekLayerContainer = '<div class="reco_cinema__article-eek-layer-container">';

        const componentLabel = getComponentLabel(energyEfficiencyClass.component);
        const dataSheetLabel = getDataSheetLabel(energyEfficiencyClass.dataSheetHref);

        if (componentLabel || dataSheetLabel) {
            eekLayerContainer += `<div class="reco_cinema__article-eek-layer-labels-container">${componentLabel}${dataSheetLabel}</div>`;
        }

        eekLayerContainer += `<img src="${energyEfficiencyClass.images[0].uriTemplate}"/> </div>`;
        return eekLayerContainer;
    };

    tick().then(() => {
        if (useNewEECLabel) {
            const energyLabels = Array.from(document.querySelectorAll("ofc-energy-label-v1"));
            const elementsWithEnergyIcon = energyLabels.map((energyLabel) =>
                energyLabel.shadowRoot.querySelector("div > svg > use")
            );
            elementsWithEnergyIcon.forEach((energyIcon) =>
                energyIcon.setAttribute("href", svgImageUrlPrefix + energyIcon.getAttribute("href"))
            );
        }
    });
</script>

<div class="reco_cinema__multi-eek-container">
    <div class="reco_cinema__article-eek-container reco_cinema__article-eek">
        {#if useNewEECLabel}
            {#each energyEfficiencyClasses as energyEfficiencyClass, index}
                <div class="reco_cinema__article-eek-label oc-mt-25">
                    <oc-sheet-v1 id="eec-sheet-{index}-{randomSheetId}" oc-aria-label="default sheet without label">
                        <h3 slot="headline" class="oc-headline-100">
                            Energieeffizienzklasse {energyEfficiencyClass.component}
                        </h3>
                        {#if !energyEfficiencyClass.images[0].uriTemplate}
                            <div class="reco_cinema__article-eek-layer-container">
                                <p class="p_copy100">
                                    Aktuell stehen leider keine weiteren Informationen zur Energieeffizienzklasse dieses
                                    Artikels zur Verfügung.
                                </p>
                            </div>
                        {:else}
                            <div class="">
                                {#if energyEfficiencyClass.component || energyEfficiencyClass.dataSheetHref}
                                    <div class="pl_sheet__content" style="max-height: calc(-160px + 100vh);">
                                        <div class="reco_cinema____sheet-image-container">
                                            <img
                                                class="reco_cinema__sheet-image"
                                                src={energyEfficiencyClass.images[0].uriTemplate}
                                                alt="Energieeffizienzklasse: "
                                                loading="lazy"
                                            />
                                        </div>
                                    </div>
                                    {#if energyEfficiencyClass.dataSheetHref}
                                        <oc-button-v1
                                            variant="secondary"
                                            target="_blank"
                                            size="100"
                                            base64-href={btoa(energyEfficiencyClass.dataSheetHref)}
                                        >
                                            <a href={energyEfficiencyClass.dataSheetHref}>Produktdatenblatt (PDF)</a>
                                        </oc-button-v1>
                                    {/if}
                                {/if}
                            </div>
                        {/if}
                    </oc-sheet-v1>
                    <oc-interactive-overlay-v1
                        data-oc-sheet-v1-open
                        data-oc-sheet-v1-open.id="eec-sheet-{index}-{randomSheetId}"
                    >
                        <ofc-energy-label-v1
                            class="reco_cinema__article-eek-label-img"
                            color={energyEfficiencyClass.colorHexCode}
                            size="100"
                            variant={energyEfficiencyClass.category}
                            version={energyEfficiencyClass.uniform ? "uniform" : "default"}
                        ></ofc-energy-label-v1>
                    </oc-interactive-overlay-v1>

                    {#if energyEfficiencyClass.dataSheetHref}
                        <div class="reco_cinema__article-eek-label_energyLabelText">
                            {#if energyEfficiencyClass.displayName}
                                <span
                                    class="oc-copy-50 reco_cinema__article-eek-label_energyLabelText_energyLabelTextComponent"
                                >
                                    {energyEfficiencyClass.displayName}
                                </span>
                            {/if}
                            <oc-link-v2
                                variant="secondary"
                                class="oc-link-v1 oc-link-v1--size-50 oc-link-v1--secondary reco_cinema__article-eek-label_energyLabelText_datasheet"
                                size="50"
                                style={maxWidthStyle()}
                            >
                                <a href={energyEfficiencyClass.dataSheetHref} target="_blank" rel="noopener noreferrer">
                                    Produktdatenblatt
                                </a>
                            </oc-link-v2>
                        </div>
                    {/if}
                </div>
            {/each}
        {:else}
            {#each energyEfficiencyClasses as energyEfficiencyClass}
                <div class="reco_cinema__article-eek-label oc-mt-25">
                    <div
                        class={calculateClasses(energyEfficiencyClass)}
                        data-layer-content={getLabelHtmlSnippet(energyEfficiencyClass)}
                        data-layer-width-l="550px"
                        data-layer-width-xl="550px"
                    >
                        <img
                            src="{svgImageUrlPrefix}/assets-static/icons/{calculateEecImage(energyEfficiencyClass)}.svg"
                            data-testid={calculateEecImage(energyEfficiencyClass)}
                            alt="Energieverbrauchskennzeichnung"
                            height="20"
                            width="35"
                        />
                    </div>
                    {#if energyEfficiencyClass.dataSheetHref}
                        <div class="reco_cinema__article-eek-label_energyLabelText">
                            {#if energyEfficiencyClass.displayName}
                                <span
                                    class="oc-copy-50 reco_cinema__article-eek-label_energyLabelText_energyLabelTextComponent"
                                >
                                    {energyEfficiencyClass.displayName}
                                </span>
                            {/if}
                            <a
                                href={energyEfficiencyClass.dataSheetHref}
                                target="_blank"
                                rel="noopener noreferrer"
                                class="oc-link-v1 oc-link-v1--size-50 oc-link-v1--secondary reco_cinema__article-eek-label_energyLabelText_datasheet"
                                style={maxWidthStyle()}
                            >
                                Produktdatenblatt
                            </a>
                        </div>
                    {/if}
                </div>
            {/each}
        {/if}
    </div>
</div>

<style lang="scss">
    .reco_cinema__article-eek-container {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }

    .reco_cinema__article-eek-label {
        white-space: nowrap;
        display: flex;
        align-items: center;
        width: 100%;

        &_energyLabelText {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            width: calc(100% - 40px);

            &_energyLabelTextComponent {
                cursor: default;
                text-overflow: ellipsis;
                overflow: hidden;
                margin-left: 4px;
                width: 100%;
            }

            &_datasheet {
                margin-left: 4px;
                text-overflow: ellipsis;
                overflow: hidden;
            }
        }
    }

    .reco_cinema__article-eek-label:first-of-type {
        margin-top: unset !important;
    }

    .clickable {
        cursor: pointer;
    }

    :global(.reco_cinema__article-eek-layer-container) {
        margin: 16px auto;
        text-align: center;

        :global(.reco_cinema__article-eek-layer-title) {
            font-weight: 400;
            font-size: 20px;
            text-align: left;
            padding-left: 16px;
        }

        :global(.reco_cinema__article-eek-layer-datasheet) {
            text-align: left;
            display: block;
            padding-left: 16px;
        }

        :global(.reco_cinema__article-eek-layer-label) {
            margin-bottom: 16px;
        }

        :global(.reco_cinema__article-eek-layer-labels-container) {
            margin-bottom: 24px;
        }
    }

    .reco_cinema____sheet-image-container {
        display: flex;
        justify-content: center;
    }

    .reco_cinema__sheet-image {
        width: 100%;
    }
</style>
